// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_37Hca","more-from-fit":"JNhWK","stories":"_2tCqG"};